import { render, staticRenderFns } from "./BecomePartner.vue?vue&type=template&id=93f73b1e&scoped=true"
import script from "./BecomePartner.vue?vue&type=script&lang=js"
export * from "./BecomePartner.vue?vue&type=script&lang=js"
import style0 from "./BecomePartner.vue?vue&type=style&index=0&id=93f73b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f73b1e",
  null
  
)

export default component.exports